import { render, staticRenderFns } from "./PendingProposalListing.vue?vue&type=template&id=689ab5cd"
import script from "./PendingProposalListing.vue?vue&type=script&lang=js"
export * from "./PendingProposalListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports